<script>
import { BFormDatalist } from "bootstrap-vue";

export default {
  extends: BFormDatalist
};
</script>